import shortid from "shortid"

function OrderDiningItem({ dinItem, setCurrentItem, oosid }) {
  let oos = oosid.filter(item => item === dinItem.id)

  const handleSet = (currentItem) => {
    setCurrentItem({
      show: true,
      ...currentItem
    })
  }

  return (
    <div className="order-dining-item">

      <div className="od-image-button-container">
        {dinItem.pic !== null ?
          <img className="od-image" src={dinItem.pic} alt="dining item" /> : 
          <img className="od-image" src="https://picsum.photos/720/480" alt="dining item" />
        }
        {oos.length === 0 ?
          <button className="od-order-button" onClick={() => {handleSet(dinItem)}}>Order</button> :
          <button className="od-oos-button">Out of Stock</button>
        }
      </div>

      <div className={oos.length === 0 ? "od-text-container" : "od-text-container-oos"}>

        {/* Name */}
        <div className="od-name">
          <span>{dinItem.name}</span>
        </div>

        {/* Price */}
        {dinItem.name !== "Garlic Knots" ?
          dinItem.price.length === 1 ?
          <div className="od-price">
            <p>${dinItem.price}</p>
          </div> :
          dinItem.price.map(item => (
            <div className="od-price" key={shortid.generate()}>
              <span>${item}</span>
            </div>
          )) 
        : null}

        <div className="od-quan-unit">

          {/* Quantity */}
          {dinItem.quantity ?
            <div className="od-quan">
              <span>{dinItem.quantity}</span>
            </div> : null
          }

          {/* Unit */}
          <div>
            {dinItem.unit !== null ?
              dinItem.unit.map(item => (
                item === dinItem.unit[dinItem.unit.length - 1] ?
                  <div className="od-unit" key={shortid.generate()}>
                    <span>{`${item}`}</span>
                  </div> :
                  <div className="od-unit-x" key={shortid.generate()}>
                    <span>{`*${item} or`}</span>
                  </div>
              ))
            : null}
          </div>
        </div>

        {/* Note */}
        <div className="od-note-container">
          {dinItem.note !== null ?
            dinItem.note.map(item => (
              item === dinItem.note[dinItem.note.length -1] ?
                <div className="od-note" key={shortid.generate()}>
                  <span>{`${item}`}</span>
                </div> :
                <div className="od-note-x" key={shortid.generate()}>
                  <span>{`${item},`}</span>
                </div>
            ))
          : null}
        </div>
      </div>
    </div>
  )
}

export default OrderDiningItem
